import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  C4_P1_S1_Title: {
    id: `case04.page01.slide01.title`,
  },
  C4_P1_S1_Description: {
    id: `case04.page01.slide01.description`,
  },
});
